/* eslint-disable */
import api from "@/api";
import router from "@/router";
import {defineStore} from "pinia/dist/pinia";
import packageJson from "../../package.json";
import {getAuthenticatedRequest} from "@/stores/AuthenticatedRequest.js";
import {useApi} from '@/services/useApi';
import {client} from '@/stores/client.js'

export const useUserStore = defineStore('user', {
  state: () => ({
    username: '',
    password: '',
    credential: '',
    id: 0,
    permissions: [],
    profile: {},
    activeSessions: [],
    errorMessage: '',
    preferences: {
      games: {
        boost: [],
        account: [],
        currencyBuy: [],
        currencySell: [],
      }
    },
    userCompleteProfile: {},
    allUsers: [],
    allPermissions: [],
    selectedUser: {
      permissions: [],
      name: '',
      id: 0,
      username: '',
    },
    authenticatedUser: {
      id: '',
      credential: '',
    },
    user2: {
      id: 0,
      credential: '',
      username: '',
      permissions: [],
      profile: {}
    }
  }),
  getters: {
    getCredential(state) {
      if (this.hasSecondUser) {
        return state.user2.credential;
      }
      return state.credential;
    },
    getUserId(state) {
      if (this.hasSecondUser) {
        return state.user2.id;
      }
      return state.id;
    },
    getUsername(state) {
      if (this.hasSecondUser) {
        return state.user2.username;
      }
      return state.username;
    },
    getName(state) {
      if (this.hasSecondUser) {
        return state.user2.profile.name;
      }
      return state.profile.name;
    },
    getAvatar(state) {
      if (this.hasSecondUser) {
        return state.user2.profile.discordAvatar;
      }
      return state.profile.discordAvatar;
    },
    getDiscordUsername(state) {
      if (this.hasSecondUser) {
        return state.user2.profile.discordUsername;
      }
      return state.profile.discordUsername;
    },
    getProfileAttribute(state) {
      return (attribute) => {
        if (attribute in state.profile) {
          return state.profile[attribute];
        }
        //console.warn(`Attribute "${attribute}" does not exist in profile`);
        return undefined;
      };
    },
    getProfile: (state) => state.profile,
    getPermissions(state) {
      if (this.hasSecondUser) {
        return state.user2.permissions;
      }
      return state.permissions;
    },
    hasSecondUser(state) {
      if (state.user2.id === 0) {
        return false
      } else {
        return true
      }
    },
    getPassword(state) {
      return state.password;
    },
    getErrorMessage(state) {
      return state.errorMessage;
    },
    getGamePreferences(state) {
      return state.preferences.games;
    },
    getBoostGamePreferences(state) {
      return state.preferences.games.boost;
    },
    getAccountGamePreferences(state) {
      return state.preferences.games.account;
    },
    getCurrencyBuyGamePreferences(state) {
      return state.preferences.games.currencyBuy;
    },
    getCurrencySellGamePreferences(state) {
      return state.preferences.games.currencySell;
    },
    getActiveSessions(state) {
      return state.activeSessions;
    },
    getUserCompleteProfile(state) {
      return state.userCompleteProfile;
    },
    hasPermission(state) {
      if (this.hasSecondUser) {
        return function (permission) {
          return state.user2.permissions.includes(permission);
        };
      }
      return function (permission) {
        return state.permissions.includes(permission);
      };
    },
    getAllPermissions(state) {
      return state.allPermissions;
    },
    getAllUsers(state) {
      return state.allUsers;
    },
    getSelectedUserPermissions(state) {
      return state.selectedUser.permissions
    }
  },
  actions: {
    async action_login(payload) {
      const request = {
        "request": 1008,
        "account": {
          "username": payload.username,
          "password": payload.password
        },
        "client": client
      };
      //console.log('action_login Request: ', request);
      await useApi(
        request,
        async (response) => {
          //console.log('action_login Success: ', response);
          this.credential = response.data.account.credential
          this.id = response.data.account.id
          this.username = response.data.account.username
          await this.action_getBasicProfile();
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          this.setErrorMessage(errorMessage)
          return errorMessage;
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          this.setErrorMessage(errorMessage)
          return errorMessage;
        }
      );
    },
    async action_getBasicProfile() {
      const request = {
        ...getAuthenticatedRequest(),
        "subRequest": 0,
      };
      //console.log('action_getBasicProfile Request: ', request);
      await useApi(
        request,
        async (response) => {
          //console.log('action_getBasicProfile Success: ', response);
          if (this.user2.id !== 0) {
            this.user2.profile = response.data.account
            this.user2.permissions = response.data.account.permissions
            this.user2.username = response.data.account.username
          } else {
            this.profile = response.data.account
            this.permissions = response.data.account.permissions
            this.username = response.data.account.username
          }
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage;
        }
      );
    },
    async saveIdentificationDocuments(payload) {
      const request = {
        "request": 1009,
        "subRequest": 1016,
        "account": {
          "id": this.id,
          "credential": this.credential,
          "firstName": payload.firstName,
          "lastName": payload.lastName,
          "address": payload.address,
          "phoneNumber": payload.phoneNumber,
          "kycIdCard": payload.kycIdCard.action ? {
            "action": "replace",
            "name": payload.kycIdCard.name
          } : {
            "name": payload.kycIdCard.name
          },
          "kycSelfie": payload.kycSelfie.action ? {
            "action": "replace",
            "name": payload.kycSelfie.name
          } : {
            "name": payload.kycSelfie.name
          }
        },
        "client": client
      };
      console.log('request: ')
      console.log(request)
      return await api.post('', request)
        .then((res) => {
          if (res.status === 200) {
            return res.data
          } else {
            console.log('response is ' + res.status)
          }
        }).then((data) => {
          //console.log("saveIdentificationDocuments: ")
          //console.log(data)
          if (data.response === 100) {
            //console.log("saveIdentificationDocuments: " + data)
            //console.log("saveIdentificationDocuments successfully")
            return true
          } else if (data.response === -100002) {
            this.resetUser('your credential is expired')
            router.push({name: 'Login'})
          } else {
            this.errorMessage = data.message
            return false
          }
        })

    },
    async action_getCompleteProfile() {
      //console.log('getCompleteProfile called')
      const request = {
        "request": 1009,
        "subRequest": 1017,
        "account": {
          "id": this.id,
          "credential": this.credential
        },
        "client": client
      };
      //console.log('action_getCompleteProfile: ', request);
      /*return await api.post('', request)
        .then((res) => {
          if (res.status === 200) {
            return res.data
          } else {
            console.log('response is ' + res.status)
          }
        }).then((data) => {
          console.log("getCompleteProfile: ")
          console.log(data.account)
          if (data.response === 100) {
            this.profile = data.account
            this.permissions = data.account.permissions
            this.username = data.account.username
          } else if (data.response === -100002) {
            this.resetUser('your credential is expired')
            router.push({name: 'Login'})
          } else {
            this.errorMessage = data.message
            return false
          }
        })*/

    },
    async action_getUserCompleteProfile(payload) {
      const request = {
        "request": 1009,
        "subRequest": 10018,
        "account": {
          "id": this.id,
          "credential": this.credential
        },
        "profile": {
          "id": payload.userId
        },
        "client": client
      };
      //console.log('request: ')
      //console.log(request)
      /*return await api.post('', request)
        .then((res) => {
          if (res.status === 200) {
            return res.data
          } else {
            console.log('response is ' + res.status)
          }
        }).then((data) => {
          if (data.response === 100) {
            this.userCompleteProfile = data.profile
          } else if (data.response === -100002) {
            this.resetUser('your credential is expired')
            router.push({name: 'Login'})
          } else {
            this.errorMessage = data.message
            return false
          }
        })*/
    },
    async action_getUserCompleteProfile2(payload) {
      const request = {
        ...getAuthenticatedRequest(),
        "subRequest": 10018,
        "profile": {
          "id": payload.userId
        },
      };
      /*return await useApi(
        request,
        (response) => {
          return {
            result: true,
            data: response.data?.profile
          }
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage;
        }
      );*/
    },
    async action_loginWithDiscord(payload) {
      const request = {
        "request": 1007,
        "account": {
          "code": payload.code
        },
        "client": client
      };
      //console.log('action_loginWithDiscord request', request)
      await api.post('', request)
        .then((res) => {
          if (res.status === 200) {
            return res.data
          } else {
            console.log('response is ' + res.status)
          }
        }).then(async (data) => {
          //console.log('action_loginWithDiscord success', data.reponse)
          if (data.response === 100) {
            this.credential = data.account.credential
            this.id = data.account.id
            await this.action_getBasicProfile();
          } else {
            this.credential = ''
            this.username = ''
            this.id = 0
            this.errorMessage = data.message
          }
        })
    },
    async action_getActiveSessions() {
      const request = {
        "request": 1009,
        "subRequest": 10013,
        "account": {
          "id": this.id,
          "credential": this.credential
        },
        "client": client
      };
      await api.post('', request)
        .then((res) => {
          if (res.status === 200) {
            return res.data
          } else {
            console.log('response is ' + res.status)
          }
        }).then((data) => {
          //console.log('action_getActiveSessions', data)
          if (data.response === 100) {
            this.activeSessions = data.account.sessions;
          } else if (data.response === -100002) {
            this.resetUser('your credential is expired');
            router.push({name: 'Login'})
          }
        })
    },
    async action_terminateSession(payload) {
      const request = {
        "request": 1009,
        "subRequest": 10014,
        "account": {
          "id": this.getUserId,
          "credential": this.getCredential,
          "session": {
            "credential": payload.credential
          }
        },
        "client": client
      };
      //console.log(request)
      return await api.post('', request)
        .then((res) => {
          if (res.status === 200) {
            return res.data
          } else {
            console.log('response is ' + res.status)
          }
        }).then((data) => {
          //console.log('action_terminateSession', data)
          if (data.response === 100) {
            return true
          } else if (data.response === -100002) {
            this.resetUser('your credential is expired')
            router.push({name: 'Login'})
          } else {
            this.errorMessage = data.message
            return false
          }
        })
    },
    async action_getAllUsers() {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 10017,
      };
      return await useApi(
        request,
        (response) => {
          //console.log('action_getAllUsers Success: ', response);
          this.allUsers = response.data.accounts
          return true;
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage;
        }
      );
    },
    async action_getAllPermissions() {
      const request = {
        'request': 10019,
        'client': client
      };
      //console.log('action_getPermissions: ', request);
      await useApi(
        request,
        (response) => {
          //console.log('action_getPermissions Success: ', response);
          this.setAllPermissions(response.data.permissions);
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          // userStore.resetUser(errorMessage);
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          // userStore.setErrorMessage(errorMessage);
        }
      );
    },
    async action_getUser(payload) {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 10018,
        'profile': {
          'id': payload.userID
        }
      };
      //console.log('action_getUser: ', request);
      /*return await useApi(
        request,
        (response) => {
          //console.log('action_getUser Success: ', response);
          /!*if (this.getUserId === payload.userID) {
            this.setAbilities(response.data.profile.permissions);
          }*!/
          this.setSelectedUser(response.data.profile);
          return {
            result: true,
            data: response.data.profile
          };
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          // userStore.resetUser(errorMessage);
          return errorMessage
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          // userStore.setErrorMessage(errorMessage);
          return errorMessage
        }
      );*/
    },
    async action_setPermissions(payload) {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 10020,
        'profile': {
          'id': payload.userID,
          'permissions': payload.permissions
        }
      };
      //console.log('action_set_permissions: ', request);
      return await useApi(
        request,
        (response) => {
          console.log('action_set_permissions Success: ', response);
          return true;
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
          // userStore.resetUser(errorMessage);
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage;
          // userStore.setErrorMessage(errorMessage);
        }
      );
    },
    async action_authenticateAs(payload) {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 1018,
        'profile': {
          'id': payload.userID
        }
      };
      //console.log('action_authenticateAs: ', request);
      return await useApi(
        request,
        async (response) => {
          //console.log('action_authenticateAs Success: ', response);
          this.user2.id = response.data.account.id
          this.user2.credential = response.data.account.credential
          await this.action_getBasicProfile();
          return true;
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
          // userStore.resetUser(errorMessage);
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage;
          // userStore.setErrorMessage(errorMessage);
        }
      );
    },
    async action_addUser(payload) {
      const request = {
        "request": 1010,
        "account": {
          "name": payload.name,
          "username": payload.username,
          "password": payload.password,
        },
        "client": client
      };
      //console.log('action_addUser: ', request);
      return await useApi(
        request,
        (response) => {
          // console.log('action_addUser Success: ', response);
          return {
            result: true,
            data: response.data.account.id
          };
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
          // userStore.resetUser(errorMessage);
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage;
          // userStore.setErrorMessage(errorMessage);
        }
      );
    },
    async action_resetPassword(payload) {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 11012,
        'profile': {
          'id': payload.userID,
          'password': payload.password
        }
      };
      //console.log('action_resetPassword: ', request);
      return await useApi(
        request,
        (response) => {
          //console.log('action_resetPassword Success: ', response);
          return true;
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
          // userStore.resetUser(errorMessage);
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage;
          // userStore.setErrorMessage(errorMessage);
        }
      );
    },
    async action_searchAccounts(payload) {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 2038,
        'search': {
          'keyword': payload.keyword
        }
      };
      //console.log('action_searchAccounts: ', request);
      return await useApi(
        request,
        (response) => {
          //console.log('action_searchAccounts Success: ', response);
          return response.data.search.relatedAccounts || [];
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return false;
          // userStore.resetUser(errorMessage);
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage;
          // userStore.setErrorMessage(errorMessage);
        }
      );
    },
    async action_setAuthenticationDiscord(payload) {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 2096,
        'profile': {id: payload.userID},
        'discord': {
          'user': {
            'id': payload.discordID,
            'username': payload.discordUsername,
            'displayName': payload.discordDisplayName,
            'avatar': payload.discordAvatar
          }
        }
      };
      return await useApi(
        request,
        (response) => {
          return {
            result: true
          }
        },
        (errorMessage) => {
          //console.log('Handle Credential Expired: ', errorMessage);
          return false;
          // userStore.resetUser(errorMessage);
        },
        (errorMessage) => {
          //console.log('Handle Failure: ', errorMessage);
          return errorMessage;
          // userStore.setErrorMessage(errorMessage);
        }
      );
    },
    async action_getCompleteProfile3(payload = null) {
      const request = {
        ...getAuthenticatedRequest(),
        subRequest: 1017,
        ...(payload?.id && {
          profile: {
            id: payload.id
          }
        })
      };
      return await useApi(
        request,
        (response) => {
          const data = response.data?.profile ? response.data?.profile : response.data?.account

          if (response.data?.profile) {
            this.setSelectedUser(data);
          } else if (response.data.account) {
            this.profile = data
            this.permissions = data.permissions
            this.username = data.username
          }

          return {
            result: true,
            'data': data
          }
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage;
        }
      );
    },
    async action_getPartialProfile3(payload = null) {
      const request = {
        ...getAuthenticatedRequest(),
        subRequest: 1021,
        ...(payload?.id && {
          profile: {
            id: payload.id
          }
        })
      };

      console.log(request);
      return await useApi(
        request,
        (response) => {
          if (response.data?.profile) {
            this.setSelectedUser(response.data.profile);
          }
          return {
            result: true,
            data: response.data?.profile ? response.data?.profile : response.data?.account
          }
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage;
        }
      );
    },
    async action_saveIdentificationDocuments(payload) {
      /*const request = {
        "request": 1009,
        "subRequest": 1016,
        "account": {
          "id": this.id,
          "credential": this.credential,
          "firstName": payload.firstName,
          "lastName": payload.lastName,
          "address": payload.address,
          "phoneNumber": payload.phoneNumber,
          "kycIdCard": payload.kycIdCard.action ? {
            "action": "replace",
            "name": payload.kycIdCard.name
          } : {
            "name": payload.kycIdCard.name
          },
          "kycSelfie": payload.kycSelfie.action ? {
            "action": "replace",
            "name": payload.kycSelfie.name
          } : {
            "name": payload.kycSelfie.name
          }
        },
        "client": client
      };*/

      const request = {
        ...getAuthenticatedRequest(),
        subRequest: 1016,
        ...(payload?.profile?.id && {
          profile: {
            id: payload.profile.id,
          },
        }),
        account: {
          ...getAuthenticatedRequest().account,
          "firstName": payload.firstName,
          "lastName": payload.lastName,
          "address": payload.address,
          "phoneNumber": payload.phoneNumber,
          "kycIdCard": payload.kycIdCard?.action ? {
            "action": "replace",
            "name": payload.kycIdCard.name
          } : {
            "name": payload.kycIdCard.name
          },
          "kycSelfie": payload.kycSelfie?.action ? {
            "action": "replace",
            "name": payload.kycSelfie.name
          } : {
            "name": payload.kycSelfie.name
          }
        },
      }
      console.log(request)
      return await useApi(
        request,
        (response) => {
          console.log('action_saveIdentificationDocuments Success: ', response);
          return {
            result: true
          };
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
          // userStore.resetUser(errorMessage);
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage;
          // userStore.setErrorMessage(errorMessage);
        }
      );
    },
    setErrorMessage(payload) {
      this.errorMessage = payload
    },
    setBoostGamePreferences(payload) {
      this.preferences.games.boost = payload
    },
    setCurrencyBuyGamePreferences(payload) {
      this.preferences.games.currencyBuy = payload
    },
    setCurrencySellGamePreferences(payload) {
      this.preferences.games.currencySell = payload
    },
    setAccountGamePreferences(payload) {
      this.preferences.games.account = payload
    },
    setCredential(payload) {
      this.credential = payload
    },
    setUsername(payload) {
      this.username = payload
    },
    setUserId(payload) {
      this.id = payload
    },
    resetUser(errorMessage = '') {
      if (this.hasSecondUser) {
        this.resetUser2()
      } else {
        this.credential = ''
        this.username = ''
        this.permissions = []
        this.id = 0
      }
      this.errorMessage = errorMessage
      client.firebaseID = null
      localStorage.removeItem('firebaseID')
    },
    resetUser2() {
      this.user2.credential = ''
      this.user2.username = ''
      this.user2.permissions = []
      this.user2.id = 0
    },
    setAllPermissions(permissions) {
      this.allPermissions = permissions;
    },
    setSelectedUser(payload) {
      this.selectedUser = payload
      this.selectedUser.permissions = payload.permissions
    },
    setSelectedUserData(payload) {
      this.selectedUser.name = payload.name
      this.selectedUser.username = payload.username
      this.selectedUser.id = payload.id
    },
  },
  persist: {
    paths: ['credential', 'id', 'username', 'preferences', 'permissions', 'user2.id', 'user2.credential', 'user2.username', 'user2.permissions'],
  },
})


